import {
  IGetPeriodCycleCountDetailRequest,
  IGetPeriodCycleCountDetailSplitRequest,
  IGetPeriodCycleCountRequest,
  IImportPeriodCycleCountByLocation,
  IImportPeriodCycleCountByProduct,
  IPaginationRequest,
  IPeriodCycleCount,
} from "model";
import { BaseApiService } from "./BaseApiService";
const prefix = "CycleCount";
const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};

const URL_GET_ALL_CYCLE_COUNT = getUrl("get-all-cycle-count-history");
const URL_IMPORT_PERIOD_CYCLE_COUNT_BY_LOCATION = getUrl(
  "import-period-cycle-count-by-location"
);
const URL_IMPORT_PERIOD_CYCLE_COUNT_BY_PRODUCT = getUrl(
  "import-period-cycle-count-by-product"
);
const URL_GET_PERIOD_CYCLE_COUNT = getUrl("get-cycle-count-period");
const URL_GET_PERIOD_CYCLE_COUNT_DETAIL = getUrl(
  "get-cycle-count-period-detail"
);
const URL_GET_PERIOD_CYCLE_COUNT_DETAIL_SPLIT = getUrl(
  "get-cycle-count-period-detail-split"
);
const URL_IMPORT_PERIODIC_CYCLE_COUNT_CONFIRM_LOCATION = getUrl(
  "import-period-cycle-count-detail-confirm"
);
class CycleCountApiService extends BaseApiService {
  /**
   * @param IPaginationRequest
   * @returns any
   */
  public getAllCycleCounts = (request: IPaginationRequest) =>
    this.get<any>(URL_GET_ALL_CYCLE_COUNT, {
      params: request,
    });

  /**
   * @param IImportPeriodCycleCountByLocation
   * @returns any
   */
  public importPeriodCycleCountByLocation = (
    request: IImportPeriodCycleCountByLocation
  ) => this.postForm<any>(URL_IMPORT_PERIOD_CYCLE_COUNT_BY_LOCATION, request);

  /**
   * @param IImportPeriodCycleCountByProduct
   * @returns any
   */
  public importPeriodCycleCountByProduct = (
    request: IImportPeriodCycleCountByProduct
  ) => this.postForm<any>(URL_IMPORT_PERIOD_CYCLE_COUNT_BY_PRODUCT, request);

  /**
   * @param IGetPeriodCycleCountRequest
   * @returns any
   */
  public getPeriodicCycleCount = (request: IGetPeriodCycleCountRequest) =>
    this.get<any>(URL_GET_PERIOD_CYCLE_COUNT, { params: request });

  /**
   * @param IGetPeriodCycleCountDetailRequest
   * @returns any
   */
  public getPeriodicCycleCountDetail = (
    request: IGetPeriodCycleCountDetailRequest
  ) => this.get<any>(URL_GET_PERIOD_CYCLE_COUNT_DETAIL, { params: request });

  /**
   * @param IGetPeriodCycleCountDetailSplitRequest
   * @returns any
   */
  public getPeriodicCycleCountDetailSplit = (
    request: IGetPeriodCycleCountDetailSplitRequest
  ) =>
    this.get<any>(URL_GET_PERIOD_CYCLE_COUNT_DETAIL_SPLIT, { params: request });

  /**
   * @param IGetPeriodCycleCountDetailSplitRequest
   * @returns any
   */
  public importPeriodicCycleCountConfirmLocation = (
    request: IGetPeriodCycleCountDetailSplitRequest
  ) =>
    this.postForm<any>(
      URL_IMPORT_PERIODIC_CYCLE_COUNT_CONFIRM_LOCATION,
      request
    );
}

export default new CycleCountApiService();
